import {
	defineMessages
} from 'react-intl';

export default defineMessages({
	title: {
		'id': 'features.title',
		'defaultMessage': 'FreshMint Features',
	},
	titleIcon1: {
		'id': 'features.icon1.title',
		'defaultMessage': 'Remote control',
	},
	labelIcon1: {
		'id': 'features.icon1.label',
		'defaultMessage': 'With mobile and desktop apps.',
	},
	titleIcon2: {
		'id': 'features.icon2.title',
		'defaultMessage': 'Security',
	},
	labelIcon2: {
		'id': 'features.icon2.label',
		'defaultMessage': 'Your device is not publicly visible on the web and uses encrypted communication for additional security.',
	},
	titleIcon3: {
		'id': 'features.icon3.title',
		'defaultMessage': 'Mobile',
	},
	labelIcon3: {
		'id': 'features.icon3.label',
		'defaultMessage': 'FreshMint is a system of rapid deployment and redeployment that is fast and easy to plug, unplug and move around',
	},
	titleIcon4: {
		'id': 'features.icon4.title',
		'defaultMessage': 'A.I. assistance',
	},
	labelIcon4: {
		'id': 'features.icon4.label',
		'defaultMessage': 'Machine learning algorithm constantly gathers non-personal information about how to improve growing recipes. You can harness its power at your disposal',
	},
	titleIcon5: {
		'id': 'features.icon5.title',
		'defaultMessage': 'Expandable',
	},
	labelIcon5: {
		'id': 'features.icon5.label',
		'defaultMessage': 'The main unit can be expanded with ancillary grow chambers to become even more price-effective',
	},
	titleIcon6: {
		'id': 'features.icon6.title',
		'defaultMessage': 'Ergonomical',
	},
	labelIcon6: {
		'id': 'features.icon6.label',
		'defaultMessage': 'All components that require maintenance are placed within easy manual reach',
	}
});


// WEBPACK FOOTER //
// ./src/components/LandingFeatures/messages.js